<template>
  <div>
    <el-dialog
      :title="$t('default.userInfo')"
      @close="closeDialog"
      :visible="dialogFormVisible"
      width="600px"
      center>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item prop="type" :label="$t('default.userType')" required>
          <el-select v-model="ruleForm.type">
            <el-option :label="$t('default.normal')" value="normal"></el-option>
            <el-option :label="$t('default.organization_admin')" value="organization_admin"></el-option>
            <!-- <el-option label="doctor" value="doctor"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item  prop="organizationId" :label="$t('default.bindOrganization')" required>
          <el-select style="width: 100%" multiple v-model="ruleForm.organizationId">
            <el-option
              v-for="or in organizations"
              :key="or._id"
              :value="or._id"
              :label="or.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="ruleForm.type === 'doctor'" prop="accountId" label="accountId" required>
          <el-select v-model="ruleForm.accountId">
            <el-option label="All accounts" value="all"></el-option>
            <el-option
              v-for="account in accountIds"
              :key="account._id"
              :value="account._id"
              :label="account.username">
              {{account.username}}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('default.username')" prop="username" required>
          <el-input :disabled="!!this.ruleForm._id" v-model="ruleForm.username"></el-input>
        </el-form-item>
        <el-form-item :label="$t('default.userPassword')">
          <el-input type="password" v-model="ruleForm.password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('default.remark')" prop="remark">
          <el-input v-model="ruleForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="Account ID" prop="_id">
          <el-input disabled v-model="ruleForm._id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">{{ $t('default.cancel') }}</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">{{ $t('default.submit') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import md5 from 'js-md5'
export default {
  props: ['dialogFormVisible'],
  data () {
    return {
      organizations: [],
      accountIdMap: {},
      accountIds: [],
      ruleForm: {
        type: 'normal',
        organizationId: [],
        accountId: 'all',
        username: '',
        password: '123456',
        remark: '',
        _id: ''
      },
      rules: {
        type: [
          { required: true, message: 'please select user type', trigger: 'blur' }
        ],
        accountId: [
          { required: true, message: 'please select account', trigger: 'blur' }
        ],
        username: [
          { required: true, message: 'please enter user name', trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount () {
    this.getAllOrganizations()
    this.getAllUserAccountId()
  },
  methods: {
    closeDialog () {
      this.ruleForm = {
        type: 'normal',
        accountId: 'all',
        username: '',
        password: '123456',
        remark: '',
        _id: ''
      }
      this.$emit('update:dialogFormVisible', false)
      this.$refs.ruleForm.resetFields()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let organizationId = this.ruleForm.organizationId
          if (this.ruleForm.organizationId.length === 1) {
            organizationId = organizationId[0]
          }
          const doc = {
            password: this.ruleForm.password ? md5(this.ruleForm.password.toLowerCase()) : '',
            username: this.ruleForm.username.toLowerCase(),
            type: this.ruleForm.type,
            organizationId: organizationId,
            accountId: this.ruleForm.accountId,
            remark: this.ruleForm.remark,
            id: this.ruleForm._id
          }
          console.log(doc)
          this.$store.httpDispatch({})('insertUser', doc).then((res) => {
            const { code, data } = res.data
            if (code === 0) {
              this.ruleForm._id = data.id
              this.$notify.success({ title: 'Success', message: 'Successful operation', duration: 5000 })
              this.$emit('refresh')
            }
          }).catch((err) => {
            console.log(err)
            this.$notify.error({ title: 'Error', message: `[${err.data.code}] ${err.data.msg}`, duration: 5000 })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getAllUserAccountId () {
      let result = {}
      try {
        result = await this.$store.dispatch('getAllUserAccountId')
      } catch (err) {
        console.log(err)
        this.loading = false
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        this.accountIds = data.users
        this.accountIds.map((account) => {
          this.accountIdMap[account._id] = account.username
        })
      }
    },
    async getAllOrganizations () {
      let result = {}
      try {
        result = await this.$store.dispatch('getAllOrganizations')
      } catch (err) {
        console.log(err)
        this.loading = false
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        this.organizations = data.organizations
      }
    },
    edit (row) {
      if (typeof row.organizationId === 'string') {
        row.organizationId = [row.organizationId]
      }
      this.ruleForm = {
        organizationId: row.organizationId,
        accountId: row.accountId,
        type: row.type,
        username: row.username,
        password: '',
        remark: row.remark,
        _id: row._id
      }
    }
  }
}
</script>
